import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Help from '@/views/help/index/index.vue';

var ComponentName = function (_super) {
  __extends(ComponentName, _super);

  function ComponentName() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ComponentName = __decorate([Component({
    components: {
      Help: Help
    }
  })], ComponentName);
  return ComponentName;
}(Vue);

export default ComponentName;